import { render } from "./MaterialForm.vue?vue&type=template&id=507c2c76&scoped=true"
import script from "./MaterialForm.vue?vue&type=script&lang=js"
export * from "./MaterialForm.vue?vue&type=script&lang=js"

import "./MaterialForm.vue?vue&type=style&index=0&id=507c2c76&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507c2c76"]])

export default __exports__